// @flow
import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import { withTheme } from 'styled-components';

type Props = {
  onClick: () => void;
  disabled?: boolean;
  label?: string;

  t: any;
  theme: any;
}

function PrintButton(props: Props) {
  const { label, t, theme, onClick, disabled } = props;

  const text = label || t('print');

  return (
    <RaisedButton
      label={text.toUpperCase()}
      onClick={onClick}
      backgroundColor={theme.colors.accent}
      labelStyle={{ color: theme.colors.tertiaryText }}
      disabled={disabled}
    />
  );
}

export default withTheme(translate()(PrintButton));



// WEBPACK FOOTER //
// ./src/statsradio/components/PrintButton.js